import React, { createContext, useState } from 'react';

export const SelectedTransactionContext = createContext(null);

export function SelectedTransactionProvider({ children }) {
  const selectedTransaction = useState();

  return (
    <SelectedTransactionContext.Provider value={selectedTransaction}>
      {children}
    </SelectedTransactionContext.Provider>
  );
}
